import { render } from "./P007.vue?vue&type=template&id=70944b07&scoped=true"
import script from "./P007.vue?vue&type=script&lang=js"
export * from "./P007.vue?vue&type=script&lang=js"

import "./P007.vue?vue&type=style&index=0&id=70944b07&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70944b07"]])

export default __exports__